import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { RentModel } from 'types/api'
import { BaseParams } from 'types/utils'

export function useRentUpdate() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  async function updateRent({
    id,
    body
  }: BaseParams<Partial<RentModel>, 'PATCH'>) {
    const res = await apiClient.patch<RentModel>(
      SNA_PREFIX + `rents/${id}/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: updateRent,
    onSuccess: () => {
      toast.success({ message: t('statusChanged') })
      queryClient.invalidateQueries({ queryKey: ['rents'] })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
      queryClient.invalidateQueries({ queryKey: ['dashboard-unpaid-rents'] })
    },
    onError // Updated to use useOnError
  })
}
